import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import type {
  PopupContainerDefinition,
  PopupContainerProps as PopupContainerPlatformProps,
} from '@wix/thunderbolt-components';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import type { PopupContainerPreviewProps } from '../PopupContainer.types';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { props as viewerPropsMapper } from './PopupContainer.mapper';

const getFillLayersPreviewProps = (
  carmiData: PopupContainerPlatformProps,
  {
    isPlayingAllowed,
    isMobileView,
    componentViewMode,
    isFullWidthPopup,
  }: {
    isPlayingAllowed: boolean;
    isMobileView: boolean;
    componentViewMode: string;
    isFullWidthPopup: boolean;
  },
) => {
  let { fillLayers } = carmiData;
  if (fillLayers.video) {
    fillLayers = JSON.parse(JSON.stringify(fillLayers));
    fillLayers.video!.videoInfo.autoPlay =
      fillLayers.video!.videoInfo.autoPlay && isPlayingAllowed;
    return {
      ...carmiData,
      fillLayers: {
        ...fillLayers,
        reducedMotion: componentViewMode === 'editor',
      },
      previewWrapperProps: {
        componentViewMode,
        isMobileView,
        autoPlayVideo: fillLayers.video?.videoInfo.autoPlay,
        isPlayingAllowed,
        isFullWidthPopup,
      },
    };
  }
  return {
    ...carmiData,
    previewWrapperProps: {
      componentViewMode,
      isFullWidthPopup,
      isMobileView,
    },
  };
};

const props = composeMapper<
  PreviewWrapperProps<PopupContainerPlatformProps, PopupContainerPreviewProps>,
  PopupContainerDefinition,
  PopupContainerPlatformProps
>()(
  viewerPropsMapper,
  {
    add: ['componentViewMode', 'isMobileView', 'isPlayingAllowed', 'compProps'],
  },
  (resolver, dependencies, carmiData: PopupContainerPlatformProps) => {
    const viewerProps = resolver(dependencies, carmiData);

    const { componentViewMode, isMobileView, isPlayingAllowed, compProps } =
      dependencies;

    const reactProps = getFillLayersPreviewProps(carmiData, {
      isPlayingAllowed,
      isMobileView,
      componentViewMode,
      isFullWidthPopup: compProps.alignmentType === 'fullWidth',
    });

    return {
      ...viewerProps,
      ...reactProps,
      previewWrapperProps: {
        ...reactProps.previewWrapperProps,
        ...compProps,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
